import { useMediaQuery } from "@react-hook/media-query";

export function useDisplaySize() {
  return useMediaQuery("(max-width: 800px)");
}

export function useXLDisplaySize() {
  return useMediaQuery("(max-width: 1200px)");
}
